import { render, staticRenderFns } from "./RcvScLPrice_List_Icon.vue?vue&type=template&id=74473ea4"
import script from "./RcvScLPrice_List_Icon.vue?vue&type=script&lang=js"
export * from "./RcvScLPrice_List_Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports